class WebSocketClient {
  constructor(url) {
    // this.url = url
    // this.connection = null
    // this.reconnectInterval = 5000 // 5 seconds
    
    this.isConnected = false
    this.wsUrl = url
    this.ws = null
    this.tt = null
    this.lockReconnect = false
  }

  // connect() {
  //   this.connection = new WebSocket(this.url)
  //   this.connection.onopen = () => {
  //     console.log('连接成功')
  //     setTimeout(()=>{
  //       // 发送在线消息
  //       this.sendMessage(JSON.stringify({
  //         bodyType: "QuoteExaminePresence",
  //         body: {
  //           state: '01',
  //           quId: JSON.parse(localStorage.getItem('user')).examineQuoteUserId
  //         }
  //       }))
  //     },1000)
  //     this.isConnected = true
  //   }

  //   this.connection.onmessage = (message) => {
  //     console.log('WebSocket 推送的消息', message.data)
  //     this.onMessage(message.data)
  //   }

  //   this.connection.onclose = () => {
  //     console.log('WebSocket 断开连接')
  //     this.isConnected = false
  //     setTimeout(() => this.connect(), this.reconnectInterval)
  //   }

  //   this.connection.onerror = (error) => {
  //     console.error('WebSocket 连接错误', error)
  //     setTimeout(() => this.connect(), this.reconnectInterval)
  //   }
  // }

  // sendMessage(message) {
  //   if (this.isConnected) {
  //     console.log('WebSocket 发送消息')
  //     console.log(this.connection.readyState,'this.connection.socket.readyState')
  //     if(this.connection.readyState === 1){
  //       console.log('WebSocket 消息发送成功')
  //       this.connection.send(message)
  //     }else{
  //       setTimeout(() => {
  //         this.sendMessage(message)
  //       }, 1000) // 1秒后重试发送消息
  //       console.log('WebSocket未准备好 消息发送失败')
  //     }
  //   } else {
  //     console.error('WebSocket中断 无法发送消息')
  //   }
  // }

  // onMessage(message) {
  //   // Override this method to handle incoming messages
  //   console.log('接收到的消息', message)
  // }

  // close() {
  //   if (this.connection) {
  //     this.connection.close()
  //   }
  // }




  createWebSocket() {
    try {
      this.ws = new WebSocket(this.wsUrl)
      this.init()
    } catch(e) {
      console.log("catch")
      this.reconnect(this.wsUrl)
    }
  }
  init() {
    this.ws.onclose = ()=> {
      console.log("链接关闭",sessionStorage.getItem('userOnline'))
      if(sessionStorage.getItem('userOnline') && sessionStorage.getItem('userOnline') === '01'){
        this.reconnect(this.wsUrl)
      }
    }
    this.ws.onerror = ()=> {
      console.log("发生异常了",sessionStorage.getItem('userOnline'))
      if(sessionStorage.getItem('userOnline') && sessionStorage.getItem('userOnline') === '01'){
        this.reconnect(this.wsUrl)
      }
    }
    this.ws.onopen = ()=> {
      console.log("连接成功")
      if(localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).examineQuoteUserId){
        // 发送在线消息
        this.ws.send(JSON.stringify({
          bodyType: "QuoteExaminePresence",
          body: {
            state: '01',
            quId: JSON.parse(localStorage.getItem('user')).examineQuoteUserId
          }
        }));
        this.ws.send(JSON.stringify({ bodyType: 'Heartbeat',body: {
          quId: JSON.parse(localStorage.getItem('user')).examineQuoteUserId
        }}));
        //心跳检测重置
        this.heartCheck.start()
      }else{
        this.ws.close()
      }
      
    }
    this.ws.onmessage = (message)=> {
      //拿到任何消息都说明当前连接是正常的
      console.log("接收到消息")
      this.onMessage(message.data)
      this.heartCheck.start()
    }
  }
  reconnect(url) {
    if(this.lockReconnect) {
      return
    }
    this.lockReconnect = true
    //没连接上会一直重连，设置延迟避免请求过多
    this.tt && clearTimeout(this.tt)
    this.tt = setTimeout(()=> {
      this.createWebSocket(url)
      this.lockReconnect = false
    }, 4000)
  }
  sendMessage(message) {
    if (this.lockReconnect) {
      console.log('WebSocket 发送消息')
      if(this.ws.readyState === 1){
        this.ws.send(message)
        console.log('WebSocket 消息发送成功')
      }else{
        console.log('WebSocket未准备好 消息发送失败')
      }
    } else {
      console.error('WebSocket中断 无法发送消息')
    }
  }
  onMessage(message) {
    // Override this method to handle incoming messages
    console.log('接收到的消息', message)
  }

  close() {
    if (this.ws) {
      this.ws.close()
    }
  }
  //心跳检测
  heartCheck = {
    timeout: 30000, // 30秒
    timeoutObj: null,
    serverTimeoutObj: null,
    start: () => {
      console.log("心跳检测开始");
      clearTimeout(this.heartCheck.timeoutObj);
      clearTimeout(this.heartCheck.serverTimeoutObj);
      this.heartCheck.timeoutObj = setTimeout(()=> {
        // 这里发送一个心跳，后端收到后，返回一个心跳消息，
        // onmessage拿到返回的心跳就说明连接正常
        this.ws.send(JSON.stringify({ bodyType: 'Heartbeat',body: {
          quId: JSON.parse(localStorage.getItem('user')).examineQuoteUserId
        }}));
        console.log("发送心跳");
        this.heartCheck.serverTimeoutObj = setTimeout(()=> {
          // 如果超过一定时间还没重置，说明后端主动断开了
          this.ws.close();
        }, this.heartCheck.timeout * 2);
      }, this.heartCheck.timeout);
    }
  }
}

export default WebSocketClient
